import { Button, Stack, Typography } from "@mui/material";
import Page from "../components/ui/Page.js";
import { ERROR_TITLES } from "../constants/messages/errors.js";
import HelpInfo from "../features/content/components/HelpInfo.js";

const NoPage = () => (
  <Page title="Page Not Found" sx={{ minHeight: "stretch" }}>
    <Stack gap={2}>
      <Typography variant="h2" fontWeight="bold">
        {ERROR_TITLES.NotFound}
      </Typography>
      <Typography>
        Uh-oh, that didn&apos;t work. Let&apos;s help you find the right
        VayKLife order page. Click the button below and have your reservation
        number handy.
      </Typography>
      <Button
        component="a"
        href="https://vayklife.com/find-your-stay"
        variant="contained"
        sx={{ alignSelf: "flex-start" }}
      >
        Find your stay
      </Button>
      <HelpInfo />
    </Stack>
  </Page>
);

export default NoPage;
